import { service } from "../utils/request";

// 优惠券
export function couponList(data) {
  return service({
    url: "coupon/agent.coupon/index",
    method: "post",
    data: data
  });
}
export function deletecoupon(data) {
  return service({
    url: "coupon/agent.coupon/del",
    method: "post",
    data: data
  });
}
export function addCoupon(data) {
  return service({
    url: "coupon/agent.coupon/add",
    method: "post",
    data: data
  });
}
export function editcoupon(data) {
  return service({
    url: "coupon/agent.coupon/edit",
    method: "post",
    data: data
  });
}
export function detailcoupon(data) {
  return service({
    url: "coupon/agent.coupon/detail",
    method: "post",
    data: data
  });
}
//优惠券核销
export function couponVerifiy(data) {
  return service({
    url: "/coupon/agent.Coupon_Data/index",
    method: "post",
    data: data
  });
}
//优惠券核销
export function coupon_use_index(data) {
  return service({
    url: "/coupon/agent.coupon_data/coupon_use_index",
    method: "post",
    data: data
  });
}
//优惠券领取
export function coupon_receive_index(data) {
  return service({
    url: "/coupon/agent.coupon_data/coupon_receive_index",
    method: "post",
    data: data
  });
}

export function coupon_gift_index(data) {
  return service({
    url: "/coupon/agent.coupon_data/coupon_gift_index",
    method: "post",
    data: data
  });
}
//优惠券核销统计新列表
export function newCouponVerifiy(data) {
  return service({
    url: "/coupon/agent.Coupon_Data/indexs",
    method: "post",
    data: data
  });
}
export function coupon_indexs(data) {
  return service({
    url: "coupon/agent.coupon_data/coupon_indexs",
    method: "get",
    params: data
  });
}

//优惠券暂停
export function couponShop(data) {
  return service({
    url: "coupon/agent/Coupon/stop",
    method: "post",
    data: data
  });
}
//优惠券延期
export function couponPostpone(data) {
  return service({
    url: "coupon/agent/Coupon/postpone",
    method: "post",
    data: data
  });
}
//用户优惠券暂停
export function couponShopUser(data) {
  return service({
    url: "coupon/agent/CouponData/stop",
    method: "post",
    data: data
  });
}
//用户优惠券撤销
export function couponCancle_expser(data) {
  return service({
    url: "/coupon/agent/CouponData/cancle_exp",
    method: "post",
    data: data
  });
}
//优惠券延期
export function couponPostponeUser(data) {
  return service({
    url: "coupon/agent/CouponData/postpone",
    method: "post",
    data: data
  });
}
